{
    "CRMConfiguration_Table_Headers_Description": "Descrizione",
    "CRMConfiguration_Table_Headers_Type": "Tipo",
    "CRMConfiguration_Table_Headers_TelSys": "Server di telefonia",
    "CRMConfiguration_Table_Headers_Partition": "Partizione",
    "CRMConfiguration_Table_Headers_Device": "Dispositivo",
    "NAME": "CRMConfigurationLanguage"
}